<ng-container *transloco="let t">
  <div class="d-flex" [class.landing]="isLanding" ngbDropdown (openChange)="checkDropDown($event)">
    <div class="cursor-pointer d-flex align-items-center" [class.open]="isDropdownOpen && isLanding" ngbDropdownToggle>
      @if(!isDropdownOpen || !isLanding){
      <img class=" me-2" src="assets/img/svg/globe.svg" alt="language" width="18" height="26">
      }
      @if(isDropdownOpen && isLanding){
      <img class=" me-2" src="assets/img/svg/globe_red.svg" alt="language" width="18" height="26">
      }
      <span class="lng-text text-uppercase">{{activeLang}}</span>
    </div>
    <div ngbDropdownMenu aria-labelledby="languageDropdown">
      @if(activeLang !== 'hr'){
      <button ngbDropdownItem (click)="changeLang('hr')">
        <span>HR</span>
      </button>
      }
      @if(activeLang !== 'en'){
      <button ngbDropdownItem (click)="changeLang('en')">
        <span>EN</span>
      </button>
      }
      @if(activeLang !== 'slo'){
      <button ngbDropdownItem (click)="changeLang('slo')">
        <span>SLO</span>
      </button>
      }
      @if(activeLang !== 'it'){
      <button ngbDropdownItem (click)="changeLang('it')">
        <span>IT</span>
      </button>
      }
    </div>
  </div>
</ng-container>